module.exports = __webpack_public_path__ + "img/mf_icon.222eceed.png";